export default "__VITE_ASSET__BrI3Hirj__"